/**
 * Locale-aware ordinal position formatter (e.g. "1st", "1°", "1.", "1er").
 *
 * Languages without a Western-style ordinal marker (zh, ko, th, vi, bg, el, ro)
 * render as the plain number.
 */

type OrdinalSuffixMap = Partial<Record<Intl.LDMLPluralRule, string>>;

const ORDINAL_SUFFIXES: Record<string, OrdinalSuffixMap> = {
    en: { one: "st", two: "nd", few: "rd", other: "th" },
    it: { other: "°" },
    es: { other: "º" },
    pt: { other: "º" },
    fr: { one: "er", other: "e" },
    de: { other: "." },
    da: { other: "." },
    cs: { other: "." },
};

export function formatPosition(position: number | null, locale: string): string {
    if (!position) return "";
    const lang = locale.slice(0, 2).toLowerCase();
    const suffixMap = ORDINAL_SUFFIXES[lang];
    if (!suffixMap) return String(position);
    try {
        const rule = new Intl.PluralRules(locale, { type: "ordinal" }).select(position);
        const suffix = suffixMap[rule] ?? suffixMap.other ?? "";
        return `${position}${suffix}`;
    } catch {
        return String(position);
    }
}
